import dayjs from 'dayjs';
import { ToastProgrammatic as Toast } from 'buefy';

export default {
  name: 'MenuList',
  props: {
    menus: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    isEditMode() {
      const { storeId } = this.$route.params;
      return !!storeId;
    },
    pathToCreateMenu() {
      return `/store/${this.$route.params.storeId}/menus/create`;
    },
  },
  methods: {
    editMenu(menuId) {
      const { storeId } = this.$route.params;

      if (storeId && menuId) {
        this.$router.push(`/store/${storeId}/menus/${menuId}`);
      } else {
        Toast.open({
          type: 'is-error',
          message: '無法取得店家資訊，請再試一次',
        });
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return 'N/A';
      return dayjs(timestamp).format('YYYY/MM/DD');
    },
  },
};
